import styled from 'styled-components';
import colors from '../../utils/colors';

export const SolutionCenterC2Text = styled.span`
	font-size: 11px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.22px;
	color: ${colors.blGrayscale300};

	&:not(.caret) {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&.can-click {
		cursor: pointer;
		pointer-events: auto;
	}

	&.breadcrumb-popover {
		color: ${colors.blGrayscale100};
	}

	&.date {
		color: ${colors.blGrayscale400};
		margin-top: 10px;		
	}
`;

export const SolutionCenterH3 = styled.h3`
	font-size: 23px;
	font-weight: 700;
	line-height: 32px;
	margin-bottom: 8px;
	color: ${colors.blGrayscale100};

	&.category {
		background: linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		margin: 20px 0;
	}
`;

export const SolutionCenterUl = styled.ul`
	display: flex;
	flex-direction: column;
	list-style-type: none;
	margin: 0;
	padding: 0;

	&.breadcrumb-popover {
		border-radius: 12px;
		background: ${colors.blGrayscale800};
		box-shadow: 0px 11px 130px 0px rgba(26, 26, 31, 0.23), 0px 2.457px 29.037px 0px rgba(26, 26, 31, 0.14), 0px 0.732px 8.645px 0px rgba(26, 26, 31, 0.09);
	}
`;

// Drawer Header

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 20px 26px;
	width: 425px;
	transition: border-color 250ms;
	border-bottom: 1px solid ${colors.blGrayscale700};
`;

export const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const HeaderRight = styled.div`
	display: flex;
	gap: 5px;
`;

export const HeaderText = styled.h6`
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${colors.blGrayscale300};
	margin: 0;
`;

export const HeaderButton = styled.button`
	display: flex;
	padding: 6px;
	align-items: center;
	gap: 6px;
	border-radius: 50%;
	background-color: ${colors.blGrayscale600};

	&.collapse-button {
		position: absolute;
		top: 20px;
		left: 0;
		z-index: 100;
		opacity: 1;
		border-radius: 50% 0 0 50%;
		transform: translateX(-100%);
		padding: 6px 4px;
	}
`;

// Breadcrumbs

export const BreadcrumbWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	white-space: nowrap;
	overflow: hidden;
	opacity: 1;

	&.loading-content {
		opacity: 0;
	}
`;

export const HiddenBreadcrumbButton = styled.button`
	display: flex;
	width: 16px;
	height: 16px;
	padding: 6px 0px;
	justify-content: center;
	align-items: center;
	gap: 6px;
	aspect-ratio: 1/1;
	border-radius: 100px;
	background: transparent;

	&:hover, &:active {
		background: ${colors.blGrayscale700};
	}
`;

export const BreadcrumbPopoverItem = styled.li`
	display: flex;
	align-items: center;
	align-self: stretch;
	height: 32px;
	padding: 8px 16px;
	gap: 8px;
	cursor: pointer;

	&:first-child {
		border-radius: 12px 12px 0 0;
	}

	&:last-child {
		border-radius: 0 0 12px 12px;
	}

	&:first-child:last-child {
		border-radius: 12px 12px 12px 12px;
	}

	&:hover, &:active {
		background: ${colors.blGrayscale700};
	}
`;

export const BreadcrumbContainer = styled.div`
	display: flex;
	align-items: center;

	&.hide-overflow {
		overflow: hidden;
	}
`;

// Home View

export const HomeSectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
`;

export const HomeSectionHeader = styled.span`
	font-size: 14px;
	font-weight: 500;
	line-height: 24px;
	color: ${colors.blGrayscale300};
	margin-bottom: 20px;
`;

export const ProductsList = styled.ul`
	margin: 0;
`;

export const ProductsListItem = styled.li`
	height: 18px;
	margin-bottom: 15px;
	color: #FF6AE6;
`;

export const ProductsListItemText = styled.span`
	font-size: 16px;
	font-weight: 600;
	line-height: 17px;
	margin-bottom: 15px;
	background: linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	cursor: pointer;
`;

export const RecentActivityHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const RecentActivityIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	background-color: ${colors.blGrayscale600};
	border-radius: 100px;

	svg {
		width: 16px;
		height: 16px;
	}
`;

export const RecentActivityText = styled.span`
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${colors.paleGreen};
	cursor: pointer;
`;

export const RecentActivityIconLink = styled.a`
	display: inline;
	cursor: pointer;

	svg {
		vertical-align: -3px;
	}

	&:active, &:focus {
		box-shadow: none;
	}
`;

// Category & Section Views

export const SectionHeader = styled.span`
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	color: ${colors.blGrayscale100};
	pointer-events: none;

	&.can-click {
		cursor: pointer;
		pointer-events: auto;
	}
`;

export const SectionList = styled.ul`
	padding-inline-start: 20px;
	margin-bottom: 0;

	&.show-section-link {
		margin-bottom: 20px;
	}

	li:not(:first-of-type) {
		margin-top: 4px;
	}

	li:not(:last-of-type) {
		margin-bottom: 4px;
	}
`;

export const SectionListItem = styled.li`
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${colors.paleGreen};
	cursor: pointer;
`;

export const SectionExpandText = styled.span`
	font-size: 11px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.22px;
	color: ${colors.paleGreen};
	cursor: pointer;
	margin-bottom: 20px;
`;

export const SectionContainer = styled.div`
	padding-bottom: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid ${colors.blGrayscale400};
	height: 100%;

	:last-child, &.section-view {
		margin-bottom: 0;
		border-bottom: transparent;
	}

	&.section-view {
		${SectionHeader} {
			font-size: 23px;
			font-weight: 700;
			line-height: 32px;
		}
	}
`;

// Search View

export const SearchItem = styled.li`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${colors.blGrayscale400};
	padding-bottom: 25px;

	&.recent-activity {
		padding-bottom: 20px;
	}

	&:not(:first-child) {
		padding-top: 25px;

		&.recent-activity {
			padding-top: 20px;
		}
	}

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const SearchItemTitle = styled.h6`
	font-size: 14px;
	font-weight: 700;
	line-height: 160%;
	margin: 0;
	color: ${colors.paleGreen};
	cursor: pointer;
	white-space: nowrap;

	&.truncate {
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const SearchItemBreadcrumbs = styled.div`
	display: flex;
	margin-bottom: 12px;

	${SearchItemTitle} {
		font-weight: 400;
	}
`;

export const SearchItemSnippet = styled.p`
	font-size: 14px;
	font-weight: 400;
	line-height: 160%;
	color: ${colors.blGrayscale100};
	margin: 0;

	::first-letter {
		text-transform: uppercase;
	}
`;

// Pagination

export const PaginationButtonContainer = styled.div`
	display: flex;
	width: 24px;
	height: 24px;
	padding: 6px 0px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	aspect-ratio: 1/1;

	:hover {
		cursor: pointer;
	}

	&.selected {
		border-radius: 100px;
		background: ${colors.blGrayscale700};
	}

	&.ellipses {
		padding: 8px 0 4px 0;

		:hover {
			cursor: default;
		}
	}
`;

export const PaginationNumber = styled.span`
	font-size: 10px;
	font-weight: 600;
	line-height: 14px;
	letter-spacing: -0.2px;
	color: ${colors.blGrayscale300};
	text-align: center;
	transition: color 150ms ease-in-out;
`;

export const PaginationControlsWrapper = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	display: flex;
	width: 100%;
	padding: 24px 26px;
	background: ${colors.blGrayscale900};

	&.searching {
		pointer-events: none;

		${PaginationNumber} {
			color: ${colors.blGrayscale400};
		}

		svg { 
			path {
				fill: ${colors.blGrayscale400} !important;
			}
		}
	}
`;

// General

export const SearchContainer = styled.div`
	position: relative;
`;

export const SearchEl = styled.input`
	display: flex !important;
	align-items: center;
	gap: 8px;
	padding: 8px 16px 8px 40px !important;
	margin: 0 0 40px 0 !important;
	border-radius: 16px !important;
	border: 1px solid ${colors.blGrayscale400} !important;
	background: transparent !important;
	font-size: 12px !important;
	font-weight: 500;
	line-height: 16px !important;
	letter-spacing: 0.24px;
	color: ${colors.blGrayscale400} !important;
`;

export const SearchIcon = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #908CA0;
`;

// taken from the support.brandlive.com's own stylesheet
export const SectionArticle = styled.section`
	padding: 20px 0 0;
	width: 100%;

	h1,.h1,h2,.h2,h3,.h3,h4,.h4,h5,.h5,h6,.h6 {
		margin-top: 0;
		margin-bottom: 0.5rem
	}

	p {
		margin-top: 0;
		margin-bottom: 1rem
	}

	h2,.h2,h3,.h3,h4,.h4,h5,.h5,h6,.h6 {
		max-width: 100%;
		color: #fff;
		font-weight: 700;
		letter-spacing: -0.2px
	}

	h1,.h1 {
		max-width: 100%;
		margin: 0 0 16px;
		font-size: 68px;
		line-height: 96px;
		letter-spacing: -0.2px;
		font-weight: 800;
		color: #fff
	}

	h2,.h2 {
		/* margin: 0 0 8px;
		font-size: 40px;
		line-height: 56px; */

		// GREENROOM TAB
		font-size: 16px;
		font-weight: 600;
		line-height: 20px;
		color: ${colors.blGrayscale100};
	}

	h3,.h3 {
		/* font-size: 32px;
		line-height: 48px; */

		// GREENROOM TAB
		font-size: 14px;
		font-weight: 700;
		line-height: 160%;
		color: ${colors.blGrayscale100};
	}

	h4,.h4 {
		font-size: 28px;
		line-height: 40px
	}

	h5,.h5 {
		font-size: 18px;
		line-height: 24px
	}

	h6,.h6 {
		font-size: 16px;
		line-height: 24px
	}

	time {
		font-size: 12px;
		line-height: 15px
	}

	p {
		max-width: 100%;
		margin-bottom: 8px;
		/* font-size: 16px; */
		/* line-height: 24px; */
		/* letter-spacing: -0.2px; */
		/* color: #fff; */

		// GREENROOM TAB
		font-size: 14px;
		font-weight: 400;
		line-height: 160%;
		color: ${colors.blGrayscale100};
	}

	*,*::before,*::after {
		box-sizing: border-box
	}

	.section-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		max-width: 1344px;
		margin: 0 auto;
		padding: 0 60px;
		z-index: 101
	}

	.section-container.direction-column {
		display: block
	}

	.page-content .section-container {
		display: block
	}

	.content {
		position: relative
	}

	img {
		max-width: 100%;
		height: auto;
		display: inline-block;
		transform: translate3d(0, 0, 0);
	}

	a {
		display: inline-block;
		outline: none;
		text-decoration: none;
		color: ${colors.paleGreen};
	}

	a:hover,a:focus,a:active {
		outline-width: 0;
		outline: none;
		text-decoration: none;
		box-shadow: none;
	}

	ul, ol {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	ol {
		margin-top: 0;
		margin-bottom: 1rem;
		list-style: none;
		counter-reset: li;
		padding-right: 30px
	}

	ol li {
		counter-increment: li;
		margin-bottom: 30px;
		line-height: 1.4em;
		color: #fff
	}

	ol li::before {
		content: counter(li);
		position: absolute;
		display: inline-block;
		width: 2em;
		height: 2em;
		margin-left: -2.5em;
		margin-right: 0.5em;
		padding-top: 0.25em;
		border-radius: 100px;
		background: #1ba8e1;
		font-size: 1em;
		font-weight: 700;
		vertical-align: middle;
		text-align: center;
		color: #fff
	}

	ul {
		margin-top: 1rem;
		margin-bottom: 1rem
	}

	ul li {
		margin-bottom: 16px;
		font-size: 16px;
		line-height: 1.3
	}

	// Section Specific

	.section-container {
		display: flex;
		gap: 60px
	}

	.article {
		width: 100%;
		max-width: 804px;
		margin: 0 auto
	}

	.article h2 {
		/* font-size: 28px; */
		/* line-height: 40px; */
		display: flex;
		position: relative;
		padding: 0 35px 0 0;
		margin: 0 0 8px;

		// GREENROOM TAB
		font-size: 20px;
		font-weight: 600;
		line-height: 26px;
		letter-spacing: -0.2px;
		color: ${colors.blGrayscale100};
	}

	.article h2:not(:first-child) {
		margin-top: 48px
	}

	.article h2 .copy-link {
		position: absolute;
		right: 0;
		top: -2px;
		cursor: pointer
	}

	.article h2 .copy-link i {
		font-size: 20px;
		line-height: 1
	}

	.article h2 .copy-link .popover {
		left: 50%;
		transform: translateX(-50%);
		margin: 0;
		min-width: 110px;
		top: calc(100% - 10px);
		visibility: hidden;
		opacity: 0;
		pointer-events: none;
		z-index: 87;
		transition: 0.2s top, 0.2s opacity, 0.2s visibility;
		background: #FFFFFF;
		border-radius: 3px;
		position: absolute;
		border: 1px solid #E7E7E7;
		font-size: 14px;
		text-align: center;
		font-weight: 400;
		line-height: 32px;
		color: #080D06
	}

	.article h2 .copy-link .popover:before {
		background: #FFFFFF;
		border: 1px solid #E7E7E7;
		border-left: 0;
		border-bottom: 0;
		content: '';
		display: block;
		width: 12px;
		height: 12px;
		position: absolute;
		top: -6px;
		left: 50%;
		transform: translateX(-50%) rotate(-45deg)
	}

	.article h2 .copy-link .popover.active {
		top: calc(100% + 12px);
		opacity: 1;
		pointer-events: auto;
		visibility: visible
	}

	.article h2+.faq-item {
		margin-top: 20px
	}

	.article h3 {
		font-size: 18px;
		line-height: 24px
	}

	.article p {
		margin-bottom: 16px
	}

	.article p a span {
		word-wrap: break-word
	}

	.article img {
		margin: 15px 0
	}

	.article .article-body h1 {
		margin-bottom: 50px
	}

	.article .article-body>ol,.article .article-body .faq-item ol {
		list-style: number;
		padding: 0 0 0 18px;
		margin: 0 0 16px
	}

	.article .article-body>ol li,.article .article-body .faq-item ol li {
		padding: 0;
		margin: 0
	}

	.article .article-body>ol li::marker,.article .article-body .faq-item ol li::marker {
		font-weight: 700
	}

	.article .article-body>ol li:not(:first-child),.article .article-body .faq-item ol li:not(:first-child) {
		margin: 8px 0 0
	}

	.article .article-body>ol li:before,.article .article-body .faq-item ol li:before {
		content: none
	}

	.article .article-body>ol li ul,.article .article-body>ol li ol,.article .article-body .faq-item ol li ul,.article .article-body .faq-item ol li ol {
		margin: 0
	}

	.article .article-body>ul,.article .article-body .faq-item ul {
		list-style: revert;
		padding: 0 0 0 18px;
		margin: 0 0 16px
	}

	.article .article-body>ul li,.article .article-body .faq-item ul li {
		padding: 0px;
		margin: 0
	}

	.article .article-body>ul li::marker,.article .article-body .faq-item ul li::marker {
		font-weight: 700
	}

	.article .article-body>ul li:not(:first-child),.article .article-body .faq-item ul li:not(:first-child) {
		margin: 8px 0 0
	}

	.article .article-body>ul li:before,.article .article-body .faq-item ul li:before {
		content: none
	}

	.article .article-body>ul li ul,.article .article-body>ul li ol,.article .article-body .faq-item ul li ul,.article .article-body .faq-item ul li ol {
		margin: 0
	}

	.article .faq-item {
		border-radius: 8px;
		background: rgba(255,255,255,0.06);
		padding: 24px 40px 24px 24px;
		margin: 0 0 8px;
		/* cursor: pointer; */
		position: relative
	}

	.article .faq-item h4 {
		font-size: 18px;
		line-height: 24px;
		margin: 0;
		position: relative;
		font-weight: 500
	}

	.article .faq-item h4:after {
		display: none;
		content: '';
		right: -14px;
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		width: 0px;
		height: 0px;
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-top: 4px solid #fff
	}

	.article .faq-item .faq-a {
		margin-top: 20px;
		padding: 0;
		/* display: none; */
	}

	.article .faq-item .faq-a p {
		margin: 0
	}

	.article .faq-item .faq-a p+ul,.article .faq-item .faq-a p+ol {
		margin: 15px 0 0
	}

	.article .faq-item.active .faq-a {
		display: block
	}

	.article iframe,.article video {
		max-width: 100%
	}

	.article-footer {
		margin: 80px 0 0
	}

	.article-attachments ul li {
		display: flex;
		flex-direction: column;
	}
`;

export const Shadow = styled.div`
	width: 100%;
	height: 69px;
	position: absolute;
	left: 0;
	bottom: 0;
	background: linear-gradient(0deg, #26242B 0%, rgba(38, 36, 43, 0.00) 100%);
	pointer-events: none;

	&.pagination {
		top: -69px;
		bottom: unset;
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: calc(100% - 108px);
`;

export const Body = styled.div`
	padding: 20px 26px;
	overflow-x: hidden;
	overflow-y: auto;
	width: 425px;
	height: 100%;

	&.has-pagination {
		height: calc(100% - 141px); // header height + pagination control height
	}
`;

export const Tab = styled.div`
	display: flex;
	flex-direction: column;
	-webkit-user-select: none;
	user-select: none;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	border-left: 1px solid ${colors.blGrayscale700};
	transition: border-color 250ms;
	color: #FFFFFF;
	background: ${colors.blGrayscale900};
	overflow-x: hidden;
	box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.2);
	z-index: 99;

	&.home, &.category, &.section {
		${SearchEl} {
			margin-bottom: 35px !important;
		}
	}

	&.search {
		${SearchEl} {
			margin-bottom: 25px !important;
		}
	}

	&.category {
		${LoadingContainer} {
			height: calc(100% - 180px);
		}
	}
`;

export const ComponentWrapper = styled.div`
	position: absolute;
	top: 72px;
	bottom: 0;
	right: 84px;
	width: 0px;
	transition: all 250ms ease-in-out;

	&.open {
		width: 425px;
	}

	&.collapsed {
		width: 2px;

		&:not(.transitioning) {
			.collapse-button {
				&::before {
					content: 'Solution Center';
					position: absolute;
					left: -124px;
					width: 124px;
					padding: 6px 13px;
					background-color: ${colors.blGrayscale800};
					border-radius: 8px;
					color: ${colors.blGrayscale100};
					font-size: 11px;
					font-weight: 600;
					line-height: 16px;
					letter-spacing: 0.22px;
					opacity: 0;
					transform: translateX(14px);
					transition: opacity 250ms, transform 250ms;
					pointer-events: none;
					z-index: 100;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				&:hover {
					&::before {
						opacity: 1;
						transform: translateX(-4px);			
					}
				}
			}
		}
	}

	&.closed {
		&:not(.transitioning) {
			display: none;

			.collapse-button, ${Tab} {
				opacity: 0;
				pointer-events: none;
			}
		}
	}

	&.collapsed, &.closed {
		${Header} {
			border-bottom: 1px solid transparent;
		}
	}

	&.style-packs-open {
		right: 0px;
		z-index: 100;

		&.open {
			width: 509px;
		}

		${Header} {
			width: 509px;
		}

		${Body} {
			width: 509px;
		}
	}

	&.collapsed .collapse-button {
		transform: translateX(calc(-100% + 2px));
	}

	&.collapsed:hover:not(.transitioning) {
		.collapse-button,
		.home {
			background-color: ${colors.paleGreen};
		}

		.collapse-button svg path {
			fill: ${colors.blGrayscale1200} !important;
		}
	}
		
`;
